export default "__VITE_ASSET__u7JIX5VS__"